import config from './common.js';
import notice from './notice.js';
import http from './http.js';
import dayjs from 'dayjs';
import { reject } from 'lodash';
let units = {
  // 去除输入的空格
  trim(value) {
    return value.trim();
  },
  // 删除对象空的属性
  delNull(params) {
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        if (params[key] === '' || params[key] === null) {
          delete params[key];
        }
      }
    }
  },
  install(Vue) {
    Vue.prototype.dispatch = this.dispath;
  },
  //递归查找指定父组件，emit对应方法
  dispath(componentName, name) {
    let parent = this.$parent;
    while (parent) {
      if (parent.$options.name === componentName) {
        break;
      } else {
        parent = parent.$parent;
      }
    }
    if (parent) {
      if (name) {
        parent.$emit(name);
      }
    }
    return parent;
  },
  //是否是当前机构(非下级)
  isSelfOrg({ orgId, tenantId }) {
    // console.log(orgId);
    // console.log(tenantId);
    if (!orgId && !tenantId) return true;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let currentOrganId = userInfo.organId;
    let currentTenantId = userInfo.tenantId;
    // return (!orgId || currentOrganId == orgId) && (!currentTenantId || currentTenantId == tenantId);
    return !currentTenantId || currentTenantId == tenantId;
  },
  //新版凤栖云服
  isFqyf: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/fqyf/i) == 'fqyf') {
      return true;
    } else {
      return false;
    }
  },
  hasLogin: function(data) {
    var user = data || sessionStorage.WTS_USER_3 || {};
    if (user.id) {
      return true;
    }
    return false;
  },
  goLogin: function() {
    sessionStorage.currentActiveMenu = '';
    if (localStorage.orgCode) {
      top.location.replace('/' + localStorage.orgCode + '/login' + top.location.search);
      localStorage.removeItem('localStorage');
    } else {
      top.location.replace('/login' + top.location.search);
    }
  },
  // 客服电话
  kfTell() {
    location.href = 'tel://400-9955-788';
  },
  // 客户链接
  toService() {
    location.href =
      'https://webpage.qidian.qq.com/2/chat/h5/index.html?linkType=1&env=ol&kfuin=2852150563&fid=162&key=3635f50f03b5a57b7dbb7656c9868ee1&cate=7&type=10&ftype=1&_type=wpa&qidian=true&translateSwitch=0&roleValue=1&roleData=69';
  },
  channerRouter(e) {
    let channel = config.channel;
    return e + '_' + channel;
  },
  initTree(data, dataItem, idName) {
    if (dataItem[idName] == 0) {
      data.push(dataItem);
    }
    data.forEach(item => {
      if (item.id == dataItem[idName]) {
        if (!item.children) item.children = [];
        item.children.push(dataItem);
      } else if (item.children && item.children.length > 0) {
        this.initTree(item.children, dataItem, idName);
      }
    });
  },
  notCloseModal(_this) {
    //iview表单提交按钮默认会关闭弹窗，表单提交验证需要调用次方法阻止关闭
    _this.$root.$children[0].modalLoading = false;
    _this.$nextTick(() => {
      _this.$root.$children[0].modalLoading = true;
    });
  },
  downloadFile(url, params = {}, type = 'GET', fileName, apiPermissionCode) {
    notice.showLoading('正在下载文件，请稍等片刻');
    return http({
      type: type,
      forced: true,
      responseType: 'blob',
      All: true,
      url: url,
      apiPermissionCode,
      data: params
    })
      .then(res => {
        if (res.headers['content-type'].includes('json')) {
          // 此处拿到的data才是blob
          const { data } = res;
          const reader = new FileReader();
          reader.onload = () => {
            const { result } = reader;
            const errorInfos = JSON.parse(result);
            const { msg } = errorInfos;
            notice.error(msg);
          };
          reader.onerror = err => {
            reject(err);
          };
          reader.readAsText(data);
          notice.hideLoading();
        } else {
          let urlName = url.substring(url.lastIndexOf('/') + 1);
          if (fileName) {
            this.daochu(res, fileName);
          } else if (urlName.includes('.')) {
            this.daochu(res, urlName);
          } else {
            this.daochu(res);
          }
        }
      })
      .catch(e => {
        notice.hideLoading();
        console.log(e);
      });
  },
  daochu(res, fileName = '文件') {
    try {
      if (res.headers['content-disposition']) {
        fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
      }
      // const fileName = this.detailInfo.name + ".xls";
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
      notice.hideLoading();
    } catch (error) {
      console.log(error);
      notice.hideLoading();
    }
  },
  // 下载二维码
  dataToBlob(name, data) {
    data = data.split(',')[1];
    data = window.atob(data);
    var ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i);
    }
    var blob = new Blob([ia], {
      type: 'image/jpeg'
    });
    const href = window.URL.createObjectURL(blob);
    const downloadElement = document.createElement('a');
    downloadElement.href = href;
    downloadElement.download = name + '.jpg'; // 下载后的文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 下载
    document.body.removeChild(downloadElement); // 下载完成 移除 a
    window.URL.revokeObjectURL(href); // 释放blob对象
    // var fd = new FormData();
    // fd.append('img', blob,'.png');
    // this.upload(fd)
  },
  formRule: {
    arrRequired(msg = '请输入', trigger = 'blur') {
      return {
        required: true,
        message: msg,
        trigger,
        validator(rule, value) {
          if (!value || !value.length) {
            return false;
          }
          return true;
        }
      };
    },
    objRequired(msg = '请输入') {
      return {
        required: true,
        message: msg,
        trigger: 'blur',
        validator(rule, value) {
          if (!value) {
            return false;
          }
          return true;
        }
      };
    },
    /**
     * type类型
     string: 必须是类型string。
     number: 必须是类型number。
     boolean: 必须是类型boolean。
     method: 必须是类型function。
     regexp: 必须是RegExp创建新的时不产生异常的实例或字符串RegExp。 pattern: /^[a-z]+$/,
     integer: 必须是类型number和整数。
     float: 必须是类型number和浮点数。
     array: 必须是由 确定的数组Array.isArray。
     object: 必须是 typeobject而不是Array.isArray。
     enum: 值必须存在于enum.
     date：值必须是有效的，由Date
     url: 必须是类型url。
     hex: 必须是类型hex。
     email: 必须是类型email。
     any: 可以是任何类型。
     height：正整数
     money：支持9位正整数，保留两位点后小数
     */
    required(msg = '请输入', trigger = 'change', type = '') {
      return { required: true, message: msg, type: type, trigger: trigger };
    },
    bankCard(msg = '请输入正确的银行卡', required = true) {
      return {
        required: required,
        pattern: /^([1-9]{1})(\d{14,18})$/,
        message: msg,
        trigger: 'blur'
      };
    },
    any(msg = '请输入', required = true) {
      return {
        required,
        message: msg,
        trigger: 'change'
      };
    },
    str(msg = '请输入数字或字母或汉字', required = true) {
      return {
        required: required,
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
        message: msg,
        trigger: 'change'
      };
    },
    tel(msg = '请输入正确的手机号', required = true) {
      return {
        required: required,
        pattern: /^1[1023456789]\d{9}$/,
        message: msg,
        trigger: 'blur'
      };
    },
    idCard(msg = '请输入正确的身份证号', required = true, trigger = 'change') {
      return {
        required: required,
        pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: msg,
        trigger: trigger
      };
    },
    email(required = true, msg = '请输入正确的邮箱地址') {
      return {
        required: required,
        pattern: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
        message: msg,
        trigger: 'change'
      };
    },
    height(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
        message: msg,
        trigger: 'blur'
      };
    },
    money(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /(^[0-9]{1,9}$)|(^[0-9]{1,9}[\.]{1}[0-9]{1,2}$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    weight(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    num(msg = '请输入正确的数字', required = true) {
      return {
        required: required,
        message: msg,
        trigger: 'change',
        validator(rule, value) {
          if (required && !value && value !== 0) {
            return false;
          }
          if (value && isNaN(value)) {
            return false;
          }
          return true;
        }
      };
    },
    url(msg = '请输入正确的链接地址') {
      return {
        pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
        message: msg,
        trigger: 'blur'
      };
    },
    url2(msg = '请输入正确的链接地址') {
      return {
        pattern: /(http|https|fqtd):\/\/([\w.]+\/?)\S*/,
        message: msg,
        trigger: 'blur'
      };
    },
    number(required = true) {
      return {
        required: required,
        type: 'number',
        message: '输入的类型为数字',
        trigger: 'blur',
        transform(value) {
          if (value === '') {
            return value;
          } else {
            return Number(value);
          }
        }
      };
    },
    number100(required = true) {
      return {
        required: required,
        message: '请输入1-100的整数',
        trigger: 'blur',
        validator(rule, value) {
          if (isNaN(value) || !/^(\d|[1-9]\d|100)$/.test(value)) {
            return false;
          }
          if (value * 1 < 1 || value * 1 > 100) {
            return false;
          }
          return true;
        }
      };
    },
    num100(required = true) {
      return {
        required: required,
        message: '请输入0-100的数字',
        trigger: 'blur',
        validator(rule, value) {
          if (isNaN(value)) {
            return false;
          }
          if (value * 1 < 0 || value * 1 > 100) {
            return false;
          }
          return true;
        }
      };
    },
    justIntSort(msg = '请输入0或正整数', required = true) {
      return {
        required: required,
        pattern: /^([1-9]\d*|[0]{1,1})$/,
        message: msg,
        trigger: 'blur'
      };
    },
    IntSort(msg = '请输入正整数', required = true) {
      return {
        required: required,
        pattern: /^[1-9]\d*$/,
        message: msg,
        trigger: 'blur'
      };
    },
    phone(msg = '请输入正确格式的手机号') {
      return {
        pattern: /^[1][0-9][0-9]{9}$/,
        message: msg,
        trigger: 'blur'
      };
    },
    IDNumber(msg = '请输入正确的身份证号') {
      return {
        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    strLength(msg = '请输入正确的位数', length, required = true) {
      return {
        required: required,
        message: msg,
        trigger: 'change',
        validator(rule, value) {
          if (!required && !value) return true;
          if (value.length != length) {
            return false;
          }
          return true;
        }
      };
    }
  },
  //路由切换更新左侧导航
  togglePage() {
    if (this.$route && (this.$route.meta || this.$route.meta.title != '首页')) {
      this.$nextTick(() => {
        const arr = this.$route.matched
          .filter(item => item.meta.title)
          .map(item => {
            if (item.meta.title != '首页') {
              return {
                name: item.meta.title,
                path: item.path
              };
            }
          })
          .filter(item => item);
        window.parent.postMessage({ updateNav: arr, appMessage: true }, '*');
      });
    }
  },
  // 时间处理
  formatDate(date, fmt = 'yyyy-MM-dd') {
    if (!date) {
      return '';
    }
    if (typeof date == 'string') {
      date = date.replace(/-/g, '-');
    }
    date = new Date(date);
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      'S': date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  },
  /**
   * 复制链接文本到剪切板
   * @param {*} url 需要复制的链接或者文本
   * @param {*} convert 是否转短连接
   */
  async copyUrl(url, convert, showAlert = true) {
    if (convert) {
      const res = await http({
        url: '/buz/tools/transformLongUrl',
        type: 'PUT',
        data: { url }
      });
      url = res.data;
    }
    const cInput = document.createElement('input');
    cInput.value = url;
    document.body.appendChild(cInput);
    // 选取文本域内容;
    cInput.select();
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    // Input要在正常的编辑状态下原生复制方法才会生效
    document.execCommand('Copy');
    /// 复制成功后再将构造的标签 移除
    cInput.remove();

    showAlert && notice.success('复制成功');
  },
  // 处理import selectTree from "@/components/commons/selectTree 树接收的数据结构
  dealTree(arr, parentNodeLabel, maxLevel = 2) {
    return arr.map(item => ({
      ...item,
      expand: item.nodeKey === 0 ? true : false,
      value: item.code,
      label: item.name,
      selected: false,
      parentNodeLabel: parentNodeLabel,
      children: item.children && item.children.length > 0 && item.level < maxLevel ? this.dealTree(item.children, item.name, maxLevel) : []
    }));
  },
  downloadFun(item, name) {
    const close = notice.loading('文件下载中');
    http({
      // url: "/upload/downloadByUrl",
      url: item.url,
      type: item.type || 'GET',
      responseType: 'blob',
      data: item.params
    })
      .then(res => {
        if (res.headers['content-type'].includes('json')) {
          // 此处拿到的data才是blob
          const { data } = res;
          const reader = new FileReader();
          reader.onload = () => {
            const { result } = reader;
            const errorInfos = JSON.parse(result);
            const { msg } = errorInfos;
            notice.error(msg);
          };
          reader.onerror = err => {
            reject(err);
          };
          reader.readAsText(data);
          return;
        }
        let fileName;
        if (name) {
          fileName = name;
        } else if (res.headers['content-disposition'] && res.headers['content-disposition'].indexOf('filename=') > -1) {
          fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
        } else {
          fileName = item.url.substring(item.url.lastIndexOf('/') + 1);
        }
        const blob = new Blob([res.data]); //构造一个blob对象来处理数据
        // const fileName = "xx.xls";
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) {
          //支持a标签download的浏览器
          const link = document.createElement('a'); //创建a标签
          link.download = fileName; //a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); //执行下载
          URL.revokeObjectURL(link.href); //释放url
          document.body.removeChild(link); //释放标签
        } else {
          //其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      })
      .finally(() => {
        window.setTimeout(() => {
          close();
        }, 300);
      });
  },
  // 设置字典数组数据 map = {字典code:this中赋值的key}
  setDicList(_this, map) {
    const codeList = Object.keys(map);
    return http({
      type: 'POST',
      url: '/system/dic/list',
      data: {
        codes: codeList.join(',')
      }
    }).then(res => {
      codeList.forEach(code => {
        const list = res.data[code] || [];
        _this[map[code]] = list.map(item => ({
          label: item.txt,
          value: item.value
        }));
      });
      return res.data;
    });
  },

  //统计功能次数
  getHealthTest(apiPermissionCode = '') {
    return new Promise((resolve, reject) => {
      http({
        url: '/buz/health-test',
        type: 'GET',
        data: {},
        hideAlert: true,
        apiPermissionCode
      })
        .then(res => {
          resolve();
        })
        .catch(() => {
          resolve();
        });
    });
  },
  /**
   * 处理每个页面功能点权限
   * @param {*} code 对应功能点按钮的code
   */
  pointAction(code) {
    let list = JSON.parse(localStorage.getItem('ACTION_BUTTON_TOKEN'));
    let value = null;
    list.forEach(item => {
      if (code == item.sign) {
        if (item.isExist == 1) {
          value = true;
        }
      }
    });
    return value;
  },
  /*
   * 监管报备
   */
  superviseShowVal() {
    let supervise = JSON.parse(localStorage.getItem('userInfo')).supervise;
    if (supervise == 1) {
      return false;
    } else {
      return true;
    }
  },

  /**
   *
   * @param {string} url
   * @returns 长链接转码
   */
  transUrl(url) {
    return new Promise((resolve, reject) => {
      http({
        url: '/buz/tools/transformLongUrl',
        type: 'PUT',
        data: {
          url
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  $httpRequestList: [],
  // 取消当前所有请求
  cancelhttpRequest() {
    this.$httpRequestList.forEach(c => {
      c('取消请求');
    });
    this.$httpRequestList = [];
  },
  // 删除fixed模式的图片预览
  delTableFixedPreview() {
    window.setTimeout(() => {
      const imgs = document.querySelectorAll('.ivu-table-fixed-right img');
      for (let index = 0; index < imgs.length; index++) {
        const element = imgs[index];
        element.removeAttribute('preview');
      }
    }, 100);
  },
  // 阿拉伯数字转汉字
  numberTransform(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
    if (!num || isNaN(num)) return '零';
    var english = num.toString().split('');
    var result = '';
    for (var i = 0; i < english.length; i++) {
      var des_i = english.length - 1 - i; // 倒序排列设值
      result = arr2[i] + result;
      var arr1_index = english[des_i];
      result = arr1[arr1_index] + result;
    }
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十'); // 将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零+/g, '零'); // 合并中间多个零为一个零
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万'); // 将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/亿万/g, '亿'); // 将【亿万】换成【亿】
    result = result.replace(/零+$/, ''); // 移除末尾的零
    result = result.replace(/^一十/g, '十'); // 将【一十】换成【十】
    return result;
  },
  // 添加水印
  waterMark(str) {
    if (self != top) {
      //只在顶级页面执行
      return;
    }
    console.log('加载水印');
    const id = 'waterMark';
    const canvas = document.createElement('canvas');
    const cans = canvas.getContext('2d');
    const main = document.getElementById('app');
    if (document.getElementById(id) !== null) {
      main.removeChild(document.getElementById(id));
    }
    cans.rotate((-20 * Math.PI) / 180);
    cans.font = '20px Vedana';
    cans.fillStyle = 'rgba(190, 190, 190, 0.36)';
    cans.textAlign = 'left';
    cans.textBaseline = 'Middle';
    cans.fillText(str, 0, canvas.height / 2);
    const div = document.createElement('div');
    div.id = id;
    div.style.background = 'url(' + canvas.toDataURL('image/png') + ') left top repeat';
    main.appendChild(div);
    return id;
  },
  /**
   * 获取年龄
   * @param {出生日期} birthDateString
   * @returns
   */
  getAge(birthDateString) {
    const birthDate = dayjs(birthDateString);
    const today = dayjs();
    let age = today.year() - birthDate.year();
    if (today.month() < birthDate.month() || (today.month() === birthDate.month() && today.date() < birthDate.date())) {
      age--;
    }
    return age;
  },
  /**
   * 获取保单状态 根据需要合并子状态
   * @param {*} obj 对象实体 status-保单状态 subStatus-
   * @param {*} subStatusExcludes 
   * @returns 
   */
  getPolicyStatus(obj, subStatusExcludes = ['1']) {
    if (!obj.status) {
      return '';
    }
    const status = obj.status === 'string' ? obj.status : obj.status + '';
    if (!subStatusExcludes.includes(status) && obj.subStatus) {
      return `${status}_${obj.subStatus}`;
    } else {
      return status;
    }
  },
  // 处理日期区间
  formatDateRange(obj, sourceKey, targetKeys, del) {
    /**
      var obj = {
        dateRange: ['2023-01-01', '2023-12-31']
      }
      formatDateRange(obj, 'dateRange', ['startDate', 'endDate'], true)
      console.log(obj) => { startDate: '2023-01-01', endDate: '2023-12-31' }
    */
    if(!obj || !sourceKey || !targetKeys) {
      return
    }
    const [startKey, endKey] = targetKeys
    if (obj[sourceKey] && obj[sourceKey].length) {
      const [startDate, endDate] = obj[sourceKey]
      if (startDate) {
        obj[startKey] = dayjs(startDate).format('YYYY-MM-DD');
      }
      if (endDate) {
        obj[endKey] = dayjs(endDate).format('YYYY-MM-DD');
      }
      if (del) {
        delete obj[sourceKey]
      }
    }
  },
  dicObj2DicArr(dicObj) {
    if (!dicObj) {
      return [];
    }
    if (typeof dicObj === "string" && dicObj.length) {
      const dic = JSON.parse(localStorage.dic);
      dicObj = dic[dicObj];
    }
    const dicArr = [];
    for (let key in dicObj) {
      if (dicObj.hasOwnProperty(key)) {
        const item = dicObj[key];
        dicArr.push({
          value: key,
          label: item,
        });
      }
    }
    return dicArr;
  },
};

export default units;

//加法
Number.prototype.add = function(arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (this.mul(m) + Number(arg).mul(m)) / m;
};
//减法
Number.prototype.sub = function(arg) {
  return this.add(-arg);
};
//乘法
Number.prototype.mul = function(arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};
//除法
Number.prototype.div = function(arg) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = this.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg.toString().split('.')[1].length;
  } catch (e) {}
  var len = Math.max(t1, t2);
  r1 = this * Math.pow(10, len);
  r2 = arg * Math.pow(10, len);
  return r1 / r2;
};
